import { fetchAreaService } from '@/api/base/index';

const AREA_SERVICE_LIST = 'AREA_SERVICE_LIST';
const FETCH_STATE = 'FETCH_STATE';
const UPDATE_FILTER_ID = 'UPDATE_FILTER_ID';

const state = () => ({
  list: [],
  filterId: undefined,
  fetching: false,
});

const getters = {
  areaServiceList: state =>
    state.list.filter(item =>
      state.filterId
        ? item.areaId === state.filterId &&
          item.serviceId !== 0 &&
          item.serviceId !== 1
        : true
    ),
};

const actions = {
  fetchAreaServiceList({ state, commit }, entity) {
    if (state.fetching) return;
    commit(FETCH_STATE, true);
    return fetchAreaService({
      params: entity,
    })
      .then(res => {
        const { data } = res;
        commit(AREA_SERVICE_LIST, data);
        commit(FETCH_STATE, false);
      })
      .catch(err => {
        commit(FETCH_STATE, false);
      });
  },
  updateFilterId({ commit }, id) {
    commit(UPDATE_FILTER_ID, id);
  },
};

const mutations = {
  [AREA_SERVICE_LIST](state, list) {
    state.list = list;
  },
  [FETCH_STATE](state, value) {
    state.fetching = value;
  },
  [UPDATE_FILTER_ID](state, id) {
    state.filterId = id;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
